export default "__VITE_ASSET__BGJbigBd__"